export default __webpack_public_path__ + "static/media/5.8f63b6a6.jpg";